<template>
  <Modal
    class="holamundo"
    :title="'Confirmar Restituição'"
    :active="active"
    @close="$emit('update:active', false)"
    data-testId="settle-refund-popup"
  >
    <ValidationObserver ref="settleRefundValidator" v-slot="{ invalid }">
      <ValidationProvider
        name="Restituição"
        rules="required"
        v-slot="{ errors }"
      >
        <div class="vx-col w-full mb-2">
          <label class="vs-select--label">Restituição</label>
          <v-select
            :options="pendingRefunds"
            id="Restituição"
            v-model="form.refund"
            :class="{ 'has-error': errors.length }"
            :get-option-label="getRefundOptionLabel"
            data-testId="refund-select"
          ></v-select>
        </div>
      </ValidationProvider>

      <ValidationProvider
        name="Data de Efetivação"
        rules="required"
        v-slot="{ errors }"
      >
        <div class="vx-col w-full mb-2">
          <label class="vs-datepicker--label">Data de Efetivação</label>
          <datepicker
            :format="'dd/MM/yyyy'"
            placeholder="DD/MM/YYYY"
            v-model="form.effectiveDate"
            :disabled-dates="{ from: new Date() }"
            :class="{ 'has-error': errors.length }"
            calendar-class="classeDoCalendario"
            data-testId="settle-refund-date-datepicker"
          ></datepicker>
        </div>
      </ValidationProvider>

      <vs-button
        @click="settleRefund()"
        :disabled="invalid"
        color="success"
        class="mb-2 my-5 ml-2"
        data-testId="settle-refund-save-button"
      >
        <span>Confirmar</span>
      </vs-button>
    </ValidationObserver>
  </Modal>
</template>

<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Modal from '../../components/Modal.vue';
import endorsementApi from '../../services/endorsement.api';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import { PAYMENT_METHODS } from '@/utils/constants';

export default {
  components: {
    'v-select': vSelect,
    Datepicker,
    Modal,
    ValidationObserver,
    ValidationProvider,
  },
  props: ['active', 'policyId'],
  data() {
    return {
      pendingRefunds: [],
      form: {
        refund: null,
        effectiveDate: null,
      },
    };
  },
  watch: {
    active(value) {
      if (value && this.policyId) {
        this.form = { refund: null, effectiveDate: null };
        this.pendingRefunds = [];
        this.loadPendingRefunds();
      }
    },
  },
  methods: {
    getRefundOptionLabel(option) {
      return `${
        PAYMENT_METHODS[option.paymentMethod.toUpperCase()].name
      } - ${functions.formataReal(option.refundValue)}`;
    },
    async loadPendingRefunds() {
      try {
        this.$vs.loading();
        this.pendingRefunds = await endorsementApi.getPendingRefunds(
          this.policyId,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao buscar restituições pendentes');
      } finally {
        this.$vs.loading.close();
      }
    },
    async settleRefund() {
      const valid = await this.$refs.settleRefundValidator.validate();
      if (!valid) return;

      try {
        this.$vs.loading();
        const effectiveDate = this.form.effectiveDate.toISOString().split('T')[0];
        await endorsementApi.settleRefund(this.form.refund.id, {
          effectiveDate: effectiveDate,
        });
        notify.notifySuccess(this.$vs, 'Restituição confirmada com sucesso');
        this.$emit('settled');
        this.$emit('update:active', false);
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao confirmar restituição');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
